@import '../../global/accessibility.css';

$line-separator-colour: #666666;

:host {
	display: none;
	position: absolute;
	top: 30px;
	left: 0;
	width: 100%;
	min-height: 200px;
	background: #fff;
	box-sizing: border-box;
    padding: 10px 20px;
	overflow:hidden;
	white-space: normal;

    @include oebb-popup;
    transform: none;
    z-index: 20;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.rootContainer {
    display: flex;
    flex-direction: column;

    @media #{$screen-max-md} {
        overflow-y: scroll;
        max-height: 575px;
    }
}

.counter {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid $line-separator-colour;
}

.counter__label {
    font-weight: 700;
    display: block;
}

.counter__wrapper {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    color: #000000;

    @media #{$screen-max-md} {
        flex-direction: column;
    }
}

.counter__controler {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
}

.counter__controler > button {
    background: transparent;
    border: 1px solid #000000;
    font-size: 24px;
    padding: 0;
    width: 40px;
    height: 40px;
    margin: 0 20px;

    &:last-child {
        margin-right: 0;
    }

    &:hover,
    &:focus {
        background: linear-gradient(0deg, #dce1e6 0%, #ffffff 100%);
        cursor: pointer;
    }

    &.disabled {
        border-color: transparent;
        background: #dce1e6;
        color: #666666;
        cursor: not-allowed;
    }
}



.counter__controler > input {
    @include nj-input;

    width: 40px;
    height: 40px;
    text-align: center;
}

.selected-users__list {
    color: #000000;
    margin: 0;
    padding: 0;
    list-style: none;

}

.selected-user {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 10px 0;

    .button-link {
        color: #E2002A;
        text-decoration: underline;
        background: transparent;
        border: none;
        padding: 6px 0;
		cursor: pointer;

        &:hover,
        &:focus {
            color: #666;
        }
    }

    .remove-btn {
        padding: 2px 10px;
        background: transparent;
        border: none;
        cursor: pointer;
        color: #666;
        fill: currentColor;

        &:hover,
        &:focus {
            color: #000000;
            fill: currentColor;
        }
    }
}

.rendered-cards {
    flex-basis: 100%;

    .rendered-cards__list {
        margin: 0 0 5px;
        list-style: disc;
    }
}

.add-passanger-btn {
    margin-top: 10px;
}

.opt-2 {
    table {
        border-collapse: collapse;
    }


    select {
        border: none;
    }

    td {
        padding: 15px 0 0;
    }

    .border {
        border-bottom: 1px solid $line-separator-colour;

        td {
            padding: 0 0 15px;

        }
    }

    a {
        color: red;
    }
}

.button--apply-changes {
    @include nj-button;
    text-decoration: none;

    fill: currentColor;
    vertical-align: middle;

    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 3px;
    padding-right: 3px;
}

.diverse-passenger-disclaimer {
	padding-bottom: 3px;
	border-bottom: 1px dashed $line-separator-colour;

	&:empty {
		display: none;
	}
}
